import { createRoute, type AnyRoute } from '@tanstack/react-router';
import { portalAppRoute } from '../../router/parents';
import { PortalMatterPage, PortalMattersPage } from './matters';

const parent = () => portalAppRoute;

export const portalRoutes: AnyRoute[] = [
  createRoute({ getParentRoute: parent, path: '/', component: PortalMattersPage }),
  createRoute({ getParentRoute: parent, path: 'matters/$id', component: PortalMatterPage }),
];
